// extracted by mini-css-extract-plugin
module.exports = {"bg":"Contato_bg__Qz4rf","contato":"Contato_contato__2Qehp","form":"Contato_form__371Ht","image":"Contato_image__eiAAg","textarea":"Contato_textarea__288Ts"};